import React, { useState } from 'react';

import OiFormInput from '../../../../../shared/components/OiForm/OiFormInput';

export default function TaxIdTab() {
    const [value, setValue] = useState('');

    const handleChange = event => {
        setValue(event.target.value);
    };

    const handleSubmit = event => {
        event.preventDefault();
    };

    return (
        <div className="content-background">
            <div className="content-background__wrapper">
                <h2 className="settings__header u-half-gradient-bg">Tax ID</h2>

                <div className="oi-settings__data">
                    <form className="oi-form" onSubmit={handleSubmit}>
                        <div className="oi-form__section  u-margin-top-3_5">
                            <div className="oi-form__group">
                                <OiFormInput
                                    labelClass="oi-form__label-primary"
                                    inputClass="oi-form__input-primary  u-padding-left-1_5  oi-form__reset-password oi-form__input--height4"
                                    name="taxId"
                                    type="text"
                                    label="Enter tax id"
                                    onChange={handleChange}
                                    placeholder={value ?? ''}
                                />
                            </div>
                        </div>


                    </form>
                </div>
            </div>
        </div>
    );

}


